import React from 'react';
import { OperationProgress } from '../../../../components/OperationProgress/OperationProgress';
import { useOTCSyncProgress } from '../../../../store/otcProgressStore';

export const OTCSyncProgress: React.FC = () => {
  return (
    <OperationProgress
      titles={{
        inProgress: 'Syncing OTCs from Illio...',
        complete: 'Sync Complete',
      }}
      useStore={useOTCSyncProgress}
    />
  );
};
